import React, { useState, FC, useEffect } from "react";

const addSeparators = (inputValue: any) => {
  let value = inputValue.toString();
  value = value.replace(/\s/g, "");
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

const removeSeparators = (inputValue: any) => {
  return parseInt(inputValue.replace(/\s/g, ""));
};

const NumberInput: FC<{
  name: string;
  label: string;
  value: any;
  status?: string;
  min: number;
  max: number;
  step?: number;
  disabled?: boolean;
  getValueOnChange: any;
}> = (props) => {
  const [inputValue, setInputValue] = useState<any>(
    props.value ? props.value : 0
  );

  // Gets values from props
  useEffect(() => {
    setInputValue(addSeparators(props.value));
  }, [props.value]);

  // Validate input
  const inputValueValidator = (value: number | string) => {
    let intValue: any = removeSeparators(value);
    intValue = isNaN(intValue) ? 0 : intValue;

    if (intValue >= props.min && intValue <= props.max) {
      props.getValueOnChange(intValue);
      setInputValue(addSeparators(value));
    } else {
      if (intValue < props.min) {
        props.getValueOnChange(props.min);
        setInputValue(addSeparators(props.min));
      } else if (intValue > props.max) {
        props.getValueOnChange(props.max);
        setInputValue(addSeparators(props.max));
      }
    }
  };

  // Handle change - checks if the value are 0-9 or enter
  const handleInputChange = (event: any) => {
    const charCode = event.charCode;
    console.log("char code: ", event.charCode);
    console.log("key code: ", event.keyCode);

    let isDigit = undefined;

    if (charCode !== undefined) {
      const char = String.fromCharCode(charCode);
      isDigit = /^\d+$/.test(char);
    } else {
      isDigit = false;
    }

    if (!isDigit && charCode !== 8 && charCode !== 13) {
      event.preventDefault();
    }

    setInputValue(addSeparators(event.target.value));

    event.key === "Enter" && inputValueValidator(event.target.value);
  };

  return (
    <div
      className={`number-container ${props.status}`} // ${inputValidity === false && "error"}`}
    >
      <input
        name={props.name}
        type="text"
        placeholder={props.label}
        value={inputValue}
        step={props.step}
        min={props.min}
        max={props.max}
        inputMode="decimal"
        disabled={props.disabled || false}
        onChange={(event) => handleInputChange(event)}
        onKeyPress={(event: any) => handleInputChange(event)}
        onBlur={(event) => inputValueValidator(event.target.value)}
      />
    </div>
  );
};

export default NumberInput;
